// 서버에서 내려오는 error code 중 별도의 처리가 필요한 경우, 아래에 추가하여 상수로 관리
export const ERROR_CODE = {
  // 줄겨찾기
  FAVORITE_PROBLEM_CREATION_NOT_ALLOWED: 'FAVORITE_PROBLEM_CREATION_NOT_ALLOWED',
  FAVORITE_DESIGN_TEMPLATE_LIMIT_EXCEEDED: 'FAVORITE_DESIGN_TEMPLATE_LIMIT_EXCEEDED',
  // 학원 상태가 로그인 불가능한 경우
  ACADEMY_STATUS_NOT_ELIGIBLE_TO_LOGIN: 'ACADEMY_STATUS_NOT_ELIGIBLE_TO_LOGIN',
  // 접근 불가/삭제된 나의DB 문항으로 추천 요청한 경우
  MYDB_PROBLEM_DETAIL_NOT_FOUND: 'MYDB_PROBLEM_DETAIL_NOT_FOUND',
}
